<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <form @submit="login">
                  <h1>Two Factor Authentication</h1>
                  <p class="text-muted">Enter the pin from Google Authenticator app:</p>
                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-envelope" /></span>
                    <input
                      ref="codeInput"
                      v-model="codeFromGoogle"
                      type="text"
                      class="form-control"
                      placeholder="One Time Password"
                    >
                  </div>

                  <div class="input-group">
                    <button type="button" class="btn btn-primary px-4 login-btn" @click="login">
                      Login
                      <span v-if="loading" class="btn-loader" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div v-if="errors" class="card card-inverse card-danger">
            <div class="card-header">
              Errors
            </div>
            <div class="card-block">
              {{ errors }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    codeFromGoogle: '',
    loading: false,
    errors: null,
    username: null,
    password: null,
  }),

  mounted() {
    const { timeData: credentials } = this.$store.state.user;
    if (!credentials.username || !credentials.password) {
      this.$router.push('login');
    }
    this.username = credentials.username;
    this.password = credentials.password;
    this.$store.commit('user/setTimeData', {});
    this.$refs.codeInput.focus();
  },

  methods: {
    isFormValid() {
      if (!this.codeFromGoogle) {
        this.errors = 'Please enter your code from Google Authenticator app.';
        return false;
      }
      return true;
    },
    login() {
      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      axios.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}login/auth`, {
        username: this.username,
        password: this.password,
        code: this.codeFromGoogle,
      },
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json',
        },
      })
        .then((response) => {
          if (response.data.access_token) {
            this.$store.commit('errors/setAuthError', '');
            localStorage.setItem(this.$config.tokenStorage.name, JSON.stringify(response.data));
            this.$store.commit('user/storeAccessToken', response.data.access_token);
            this.$assignAxiosHeaders(response.data.access_token);

            const userData = response.data.user;
            userData.roles.forEach((element, index) => {
              userData.roles[index].permissions = element.permissions.map(item => ({
                id: item.id,
                name: item.name,
              }));
            });
            localStorage.setItem(this.$config.userStorage.name, JSON.stringify(userData));
            this.$store.commit('user/setInfo', userData);
            this.$router.push('/admin');
          } else if (response.data.message) {
            this.errors = response.data.message;
          } else {
            this.errors = 'Server error';
          }
        })
        .catch((e) => {
          this.errors = e.response.data.message;
          console.error(e.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// TwoFactorAuthentication.vue?1aea5595